
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Karl Wild ist Verfasser des Schweizer Hotelratings. Wild arbeitet als Publizist, Hotel- und Restauranttester in Langnau am Albis ZH. `}<span className="mobile hidden">{`Er und sein Team, 16 Spezialisten aus Hotellerie und Tourismus sowie Vielreisende, haben alle aufgeführten Hotels besucht. Um die Chancengleichheit zu wahren, werden nur Hotels mit mindestens 12 Zimmern und eigenem Restaurant berücksichtigt.`}</span></p>
    <h4>{`Die Bewertungskriterien`}</h4>
    <ul>
      <li parentName="ul">{`Wertung der massgeblichen Hotel- und Restaurantführer`}</li>
      <li parentName="ul">{`Qualitätskontrollen führender Hotelvereinigungen`}</li>
      <li parentName="ul">{`Investitionstätigkeit`}</li>
      <li parentName="ul">{`Gastfreundschaft`}</li>
      <li parentName="ul">{`Charisma und Innovationsfreude des Hoteliers`}</li>
      <li parentName="ul">{`Charakter und Originalität des Hauses`}</li>
      <li parentName="ul">{`Lage, Freizeitangebot`}</li>
      <li parentName="ul">{`Preis-Leistungs-Verhältnis`}</li>
      <li parentName="ul">{`Kategorienspezifische Angebote`}</li>
      <li parentName="ul">{`Gästebewertungen`}</li>
      <li parentName="ul">{`Subjektiver Gesamteindruck der Tester`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;